import { render, staticRenderFns } from "./Service_details.vue?vue&type=template&id=5327eaec&scoped=true"
import script from "./Service_details.vue?vue&type=script&lang=js"
export * from "./Service_details.vue?vue&type=script&lang=js"
import style0 from "./Service_details.vue?vue&type=style&index=0&id=5327eaec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5327eaec",
  null
  
)

export default component.exports